/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileVector32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <g fill="none">
            <path
                fill="#F7931D"
                d="M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z"
            />
            <path
                fill={vars.white}
                fillOpacity={0.5}
                d="M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z"
            />
            <path
                fill={vars.white}
                d="M13.195 17.07l.005.01c.12.312.292.6.504.851l-.424.254c-1.414.847-2.452 2.33-2.715 3.992a1 1 0 11-.999-.078c.289-1.994 1.516-3.763 3.2-4.772l.43-.257zm5.618.003l.429.256c1.687 1.008 2.91 2.77 3.197 4.77a1 1 0 11-1.002.073c-.26-1.664-1.293-3.14-2.708-3.985l-.43-.256.013-.019c.194-.235.354-.5.47-.787l.03-.052zM16 14a2 2 0 011.937 1.5h4.592c.26 0 .471.21.471.47v.06c0 .26-.21.47-.47.47l-4.593.001a2 2 0 01-3.874 0L9.471 16.5a.47.47 0 01-.47-.47v-.06c0-.26.21-.47.47-.47h4.592A2 2 0 0116 14zm0 1a1 1 0 00-1 .98v.039l.007.098A1 1 0 1016 15z"
            />
        </g>
    </AccessibleSVG>
);

export default FileVector32;
